import { useMutation, useQueryClient } from '@tanstack/react-query';
import { patchMerchantActiveInactive } from 'Services';
import { RQ_MERCHANT_OVERRIDES, RQ_MERCHANT_RULES, RQ_SINGLE_MERCHANT } from 'Utils';
import useReduxModal from 'Hooks/reduxHelperHooks/useReduxModal';
import useAlertBanner from 'Hooks/reduxHelperHooks/useAlertBanner';
import { useTranslation } from 'react-i18next';
import { trackEvent, EventTypes, EventNames } from '@brighterion/insights';

function useActivateMerchant(merchantId: string, templateRepositoryId: number, merchantEnabled: boolean) {
    const { addTechnicalErrorModal } = useReduxModal();
    const queryClient = useQueryClient();
    const { addAlert } = useAlertBanner();
    const { t } = useTranslation();

    return useMutation(
        [RQ_SINGLE_MERCHANT, merchantId],
        () => patchMerchantActiveInactive(merchantId, templateRepositoryId, merchantEnabled),
        {
            onSuccess: () => {
                queryClient.invalidateQueries([RQ_MERCHANT_OVERRIDES]);
                queryClient.invalidateQueries([RQ_MERCHANT_RULES, templateRepositoryId, merchantId]);
                const content = merchantEnabled
                    ? t('reactivate Merchant success msg', { merchantId })
                    : t('deactivate Merchant success msg', { merchantId });
                addAlert({
                    id: 'reactivate-deactivate-merchant-success',
                    content,
                    status: 'success'
                });
                trackEvent({
                    eventType: EventTypes.track,
                    eventName: EventNames.click,
                    payload: {
                        clickIdentifier: merchantEnabled
                            ? 'Subjects - Reactivate Subject'
                            : 'Subjects - Deactivate Subject',
                        text: merchantEnabled ? 'Reactivate Subject' : 'Deactivate Subject'
                    }
                });
            },
            onError: (error: any) => {
                if (error?.status !== 400) {
                    addTechnicalErrorModal();
                }
            }
        }
    );
}

export default useActivateMerchant;
